import { Transform } from 'class-transformer';
import { isNumberString, isDateString, registerDecorator, IS_DATE, ValidatorConstraint } from 'class-validator';
import { a as applyDecorators } from './applyDecorators_chunkExport-D6nMF0T1.mjs';

function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function convertToDate(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    if (value instanceof Date) return value;
    if (isNumberString(value)) return new Date(parseInt(value));
    if (isDateString(value)) return new Date(value);
    return null;
}
function convertFromDate(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    if (value instanceof Date) return value.toISOString();
    return null;
}
function IsDate(options) {
    return applyDecorators(Transform((params)=>convertToDate(params.value), {
        toClassOnly: true
    }), Transform((params)=>convertFromDate(params.value), {
        toPlainOnly: true
    }), (object, propertyName)=>registerDecorator({
            name: IS_DATE,
            target: object.constructor,
            options,
            propertyName,
            validator: IsDateValidator
        }));
}
const isDateValidatorName = "CustomIsDate";
class IsDateValidator {
    validate() {
        return true;
    }
}
IsDateValidator = _ts_decorate([
    ValidatorConstraint({
        name: isDateValidatorName
    })
], IsDateValidator);
function getIsDateSchema() {
    return {
        type: "string",
        format: "date",
        example: "2025-04-16T17:20:23.217Z"
    };
}
function IsDateArray() {
    return applyDecorators(Transform((params)=>{
        if (!Array.isArray(params.value)) throw new Error("Value must be an array");
        return params.value.map((value)=>convertToDate(value));
    }, {
        toClassOnly: true
    }), Transform((params)=>{
        if (!Array.isArray(params.value)) throw new Error("Value must be an array");
        return params.value.map((value)=>convertFromDate(value));
    }, {
        toPlainOnly: true
    }));
}

export { IsDate as I, IsDateArray as a, getIsDateSchema as g, isDateValidatorName as i };
//# sourceMappingURL=isDate_chunkExport-HPNldj3j.mjs.map
